module.exports = __webpack_public_path__ + "static/assets/16a7e29cca0aca7e4ae5fe8f47af30a9.svg";